import Reveal from "@/pages/home/components/Reveal";

const sections = [
  {
    id: "featured",
    icon: "ri-star-line",
    title: "精选合集",
    desc: "六组主题合集，覆盖写真、自拍、旅拍与壁纸方向。",
  },
  {
    id: "categories",
    icon: "ri-filter-3-line",
    title: "主题分类",
    desc: "按类别即时筛选，快速收敛到想看的那一类内容。",
  },
  {
    id: "wallpapers",
    icon: "ri-smartphone-line",
    title: "壁纸专区",
    desc: "手机竖版与电脑横版分组，尺寸与比例一目了然。",
  },
  {
    id: "lifestyle",
    icon: "ri-calendar-line",
    title: "生活记录",
    desc: "按月份整理的日常拍摄，越靠前越新。",
  },
  {
    id: "guide",
    icon: "ri-compass-3-line",
    title: "风格指南",
    desc: "从光线、构图、配色到尺寸，读懂四类风格差异。",
  },
];

export default function SectionIndex() {
  return (
    <section className="pb-4 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {sections.map((section) => (
              <a
                key={section.id}
                href={`#${section.id}`}
                className="group h-full rounded-lg bg-background-100 border border-background-200/70 p-5 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <span className="w-11 h-11 rounded-md bg-primary-100 flex items-center justify-center text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${section.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{section.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{section.desc}</p>
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}